import { get, post, put } from '../request.js'

// 获取常见问答列表
function getCommonQAList(params) {
  return get('/channel_admin/help_center/question', params)
}

// 提交建议-我的建议
function submitAdvice(data) {
  return post('/channel_admin/help_center/advice', data)
}

// 获取建议列表-我的建议
function getAdviceList(params) {
  return get('/channel_admin/help_center/advice', params)
}

// 获取消息未读数-消息通知
function getMessageUnreadCount() {
  return get('/channel_admin/help_center/msg/count')
}

// 获取消息列表-消息通知
function getMessageList(params) {
  return get('/channel_admin/help_center/msg', params)
}

// 消息全部已读-消息通知
function messageReadAll() {
  return post('/channel_admin/help_center/msg/bulk')
}

// 消息部分已读-消息通知
function messageRead(data) {
  return put('/channel_admin/help_center/msg', data)
}
// 帮助中心，弹窗
// 每次系统消息更新后，登录渠道后台即弹窗提示系统更新消息，仅弹窗一次，支持关闭。
function helpCenterWindow(data) {
  return post('/channel_admin/help_center/window', data)
}

export { getCommonQAList, submitAdvice, getAdviceList, getMessageUnreadCount, getMessageList, messageReadAll, messageRead, helpCenterWindow }
